<template>
    <div class="w-list-extended-filter" :class="{ 'w-is-open' : open }">
        <div class="w-list-extended-filter__inner" v-if="ready">

            <button @click="toggleStatus" class="w-list-extended-filter__toggle"><span v-if="!open">Erweiterte Suche einblenden</span><span v-if="open">Erweiterte Suche ausblenden</span><span v-if="filterCount > 0">&nbsp;({{ filterCount }})</span><i class="fa" :class="{ 'fa-cogs' : !open, 'fa-close' : open }"></i></button>

            <div class="w-list-extended-filter__drawer-outer">

                <div class="w-list-extended-filter__drawer-inner">
                    <div class="w-list-extended-filter__drawer w-o-grid">

                        <div class="w-o-cell w-u-tac">
                            <input class="w-replace" id="filter_is_new" v-model="params.is_new" @change="updateParams" type="checkbox" name="is_new" :disabled="locked" /><label class="w-button w-button--large" for="filter_is_new"><i class="fa" :class="{ 'fa-check-square-o' : params.is_new, 'fa-square-o' : !params.is_new }"></i><span>Neu bei Ludovico</span></label>
                        </div>
                        <div class="w-o-cell w-o-cell--4/12@lg w-o-cell--6/12@md">
                            <label for="filter_category" class="w-input__label">Spielekategorien in der Ludothek</label>
                            <VueSelect id="filter_category" v-model="params.category" :options="categories" label="description" :reduce="category => category.id" @input="updateParams" :clearable="true" :disabled="locked"></VueSelect>
                        </div>
                        <div class="w-o-cell w-o-cell--4/12@lg w-o-cell--6/12@md">
                            <label for="filter_platform" class="w-input__label">Plattform/Konsole (bei Computer- und Videospielen)</label>
                            <VueSelect id="filter_platform" v-model="params.platform" :options="platforms" @input="updateParams" label="label" :reduce="language => language.value" :clearable="true" :disabled="locked"></VueSelect>
                        </div>
                        <div class="w-o-cell w-o-cell--4/12@lg w-o-cell--6/12@md">
                            <label for="filter_language" class="w-input__label">Sprache des Spielmaterials</label>
                            <VueSelect id="filter_language" v-model="params.language" :options="languages" @input="updateParams" label="label" :reduce="language => language.value" :clearable="true" :disabled="locked"></VueSelect>
                        </div>
                        <div class="w-o-cell w-o-cell--4/12@lg w-o-cell--6/12@md w-input">
                            <label for="filter_publisher" class="w-input__label">Verlag/Publisher</label>
                            <input id="filter_publisher" class="w-input__field" type="text" v-model="params.publisher" :disabled="locked" />
                        </div>
                        <div class="w-o-cell w-o-cell--4/12@lg w-o-cell--6/12@md w-input">
                            <label for="filter_author" class="w-input__label">Autor:innen</label>
                            <input id="filter_author" class="w-input__field" type="text" v-model="params.author" :disabled="locked" />
                        </div>
                        <div class="w-o-cell w-o-cell--4/12@lg w-o-cell--6/12@md w-input">
                            <label for="filter_tags" class="w-input__label">Schlagwörter</label>
                            <input id="filter_tags" class="w-input__field" type="text" placeholder="Themen, Inhalte, Spielmechaniken, Zielgruppen, …" v-model="params.keywords" :disabled="locked" />
                        </div>
                        <div class="w-list-extended-filter__special-group w-o-cell w-o-cell--8/12@lg w-o-cell--6/12@md w-o-grid">
                            <div class="w-o-cell w-o-cell--4/12@lg w-o-cell--6/12@md w-input">
                                <label for="filter_age" class="w-input__label">Alter</label>
                                <input id="filter_age" class="w-input__field" type="number" step="1" min="0" placeholder="Ab x Jahren" v-model="params.age" :disabled="locked" />
                            </div>
                            <div class="w-o-cell w-o-cell--4/12@lg w-o-cell--6/12@md w-input">
                                <label for="filter_player" class="w-input__label">Anzahl Spieler:innen</label>
                                <input id="filter_player" class="w-input__field" type="number" step="1" min="0" placeholder="Ab x Personen" v-model="params.player" :disabled="locked" />
                            </div>
                            <div class="w-o-cell w-o-cell--4/12@lg w-o-cell--6/12@md w-input">
                                <label for="filter_duration" class="w-input__label">Maximale Spieledauer</label>
                                <input id="filter_duration" class="w-input__field" type="number" step="1" min="0" placeholder="Bis x Minuten" v-model="params.max_duration" :disabled="locked" />
                            </div>
                        </div>
                        <div class="w-o-cell w-o-cell--4/12@lg w-o-cell--6/12@md">
                            <label for="filter_manual_language" class="w-input__label">Sprache der Anleitung</label>
                            <VueSelect id="filter_manual_language" v-model="params.manual_language" :options="manualLanguages" @input="updateParams" label="label" :reduce="manual_language => manual_language.value" :clearable="true" :disabled="locked"></VueSelect>
                        </div>

                    </div>
                </div>

                <div class="w-list-extended-filter__footer w-o-grid">
                    <div class="w-list-extended-filter__footer-inner w-o-cell w-u-tac">

                        <button class="w-list-extended-filter__reset w-button w-button--large" :disabled="locked" @click.prevent="resetParams"><i class="fa fa-trash"></i><span><span>Filter</span> zurücksetzen</span></button>
                        <button class="w-list-extended-filter__submit w-button w-button--large w-button--wide w-button--primary" :disabled="locked" @click.prevent="updateParams"><i class="fa fa-check-circle"></i><span>Filter anwenden</span></button>

                    </div>
                </div>

                <button @click="toggleStatus" class="w-list-extended-filter__close"><icon width="32" height="32" data="@icons/close.svg"/></button>

            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'ListExtendedFilter',
    data() {
        return {
            ready: false,
        };
    },
    components: {
        // FilterToggle,
    },
    computed: {
        open() {
            return this.$store.state.extendedFilterOpen;
        },
        categories() {
            return this.$store.state.config.categories;
        },
        platforms() {
            return this.$store.state.config.platforms;
        },
        languages() {
            return this.$store.state.config.languages;
        },
        manualLanguages() {
            return this.$store.state.config.manual_languages;
        },
        locked() {
            return this.$store.state.loading;
        },
        params() {
            return this.$store.state.params;
        },
        filterCount() {
            return this.$store.getters.filterCount;
        },
    },
    methods: {
        toggleStatus() {
            this.$store.commit('toggleExtendedFilter');
        },
        updateParams() {
            this.$store.commit('updateParams', this.params);
            this.$store.dispatch('gotoPage');
        },
        resetParams() {
            this.$store.commit('resetParams');
            this.$store.dispatch('gotoPage', {
                num: 1,
                hideFilter: false,
            });
        },
    },
    mounted() {
        axios({
            method: 'GET',
            responseType: 'json',
            url: this.$store.state.api + 'config',
        })
            .then((response) => {
                this.$store.commit('setConfig', response.data);
                this.ready = true;
            })
            .catch((error) => console.log(error));
    }
};
</script>

<style lang="scss">
@import '@/styles/_base.scss';
@import "@/styles/objects/_format.scss";

.w-list-extended-filter {
}
.w-list-extended-filter__inner {
    text-align: center;
}
.w-list-extended-filter__toggle {
    display: inline-flex;
    align-items: center;
    padding: $w-gutter*0.5;
    margin-bottom: $w-gutter*0.5;

    color: w-get-color("darkgray");
    &:hover {
        color: w-get-color("green");
    }

    span {
        @include w-o-format("button-large");
    }
    i + span,
    span + i {
        margin-left: $w-gutter * 0.5;
    }
}
.w-list-extended-filter__drawer-outer {
    position: relative;
    z-index: 1;

    text-align: left;

    display: none;
    .w-list-extended-filter.w-is-open & {
        display: block;
    }
}
.w-list-extended-filter__drawer-inner {
    
    background-color: w-get-color("mediumgray");
    
    @include w-media-breakpoint($until: "md") {
        display: block;

        .w-list-extended-filter.w-is-open & {
            position: fixed;
            z-index: 100;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            background-color: w-get-color("mediumgray");

            overflow-x: hidden;
            overflow-y: scroll;
        }
    }
    @include w-media-breakpoint($from: "md") {
        border-top: 1px solid w-get-color("bordergray");
    }
}
.w-list-extended-filter__drawer {
    padding-top: $w-gutter;

    @include w-media-breakpoint($until: "md") {
        padding-bottom: $w-gutter * 6;
    }
    @include w-media-breakpoint($from: "md") {
        margin: 0 auto;
        max-width: $w-max-width;
    }
}

.w-list-extended-filter__special-group {
    @include w-media-breakpoint($until: "lg") {
        display: contents;
    }
}

.w-list-extended-filter__close {
    padding: $w-gutter;
    border-radius: 50%;
    background-color: w-get-color("mediumgray");

    i {
        font-size: 2em;
    }

    @include w-media-breakpoint($until: "md") {
        display: none;

        .w-list-extended-filter.w-is-open & {
            display: block;
            position: fixed;
            z-index: 102;
            top: $w-gutter * -0.5;
            right: $w-gutter * -0.5;
        }
    }
    @include w-media-breakpoint($from: "md") {
        display: none;
    }
}
.w-list-extended-filter__footer {
    background-color: w-get-color("mediumgray");

    @include w-media-breakpoint($until: "md") {

        .w-list-extended-filter.w-is-open & {
            position: fixed;
            z-index: 101;
            right: 0;
            bottom: 0;
            left: 0;
        }
    }
}
.w-list-extended-filter__footer-inner {
    @include w-media-breakpoint($until: "md") {
        display: flex;
        border: none;

        & > * {
            flex: 0 0 50%;
            max-width: 50%;
            font-size: 1.125em;
            height: 3em;
        }
    }
    @include w-media-breakpoint($from: "md") {
        & > * {
            margin: $w-gutter*0.5;
        }
    }
}
.w-list-extended-filter__reset {
    span > span {
        @include w-media-breakpoint($until: "md") {
            display: none;
        }
    }
}
</style>
